import { apiSlice } from "../../../features/api/apiSlice";

function pick(res: any) {
  return res?.data?.data ?? res?.data ?? res;
}
function pickArr(res: any): any[] {
  const d = pick(res);
  return Array.isArray(d) ? d : [];
}

export const moderatorApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    modGetAssignments: builder.query<any[], string | void>({
      query: (dietId) => `/exam/moderator/assignments${dietId ? `?diet_id=${dietId}` : ""}`,
      transformResponse: (res: any) => pickArr(res),
      providesTags: [{ type: "ModeratorAssignments" as const, id: "LIST" }],
    }),

    modGetResults: builder.query<any, { courseId: string; dietId: string }>({
      query: ({ courseId, dietId }) =>
        `/exam/moderator/results?course_id=${courseId}&diet_id=${dietId}`,
      transformResponse: (res: any) => pick(res),
      providesTags: (_, __, { courseId, dietId }) => [
        { type: "ModeratorResults" as const, id: `${courseId}-${dietId}` },
      ],
    }),

    modSubmitFeedback: builder.mutation<any, { id: string; comment: string }>({
      query: ({ id, comment }) => ({
        url: `/exam/moderator/results/${id}/submit-feedback`,
        method: "POST",
        body: { comment },
      }),
      invalidatesTags: [
        { type: "ModeratorResults" as const, id: "LIST" },
        { type: "ModeratorAssignments" as const, id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useModGetAssignmentsQuery,
  useModGetResultsQuery,
  useModSubmitFeedbackMutation,
} = moderatorApi;
